<template>
      <div class="programCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'program', params: {} }">
          Program
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'programCreate', params: {} }">
            Create Program
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Program</v-card-title>
          <v-card-text>
            <program-form></program-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import ProgramForm from './ProgramForm.vue';

    export default {
      name: 'program',
      components: {
        ProgramForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    